import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { PyramidChart } from '../../../Common/Charts/Pyramid';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const AgeGroup = () => {
    const { chartData } = useProfileChartsDataContext();

    return (
        <PyramidChart
            title={'Faixa Etária'}
            subtitles={
                chartData?.ageGroup?.map((item) => item.description) || []
            }
            values={chartData?.ageGroup?.map((item) => item.total  ||  0) || []}
            colors={defaultColors.slice(0, chartData?.ageGroup?.length) || []}
            className='aligned-container'
        />
    );
};
